function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider/index";
import { useMemo } from "react";
var buildStyle = function(theme, direction) {
    var font = theme.font;
    var readingDirection = direction.readingDirection, end = direction.end;
    return {
        error: {
            color: font.color.danger.base
        },
        message: _objectSpread({}, readingDirection, {
            color: font.color.neutral.base,
            display: 'block',
            fontFamily: font.base.family,
            fontSize: font.base.size[2],
            fontStyle: 'normal',
            fontWeight: font.base.weight.regular,
            letterSpacing: 'normal',
            lineHeight: font.lineHeight.base,
            margin: '0.25rem 0 0 0',
            padding: 0,
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            verticalAlign: 'top',
            '> svg': _objectSpread({}, _defineProperty({}, end.padding, '4px'), {
                position: 'relative',
                top: '-1px',
                verticalAlign: 'middle'
            })
        })
    };
};
var useStyle = function(param) {
    var hasError = param.hasError, isRtl = param.isRtl;
    var ref;
    var ref1 = (ref = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref !== void 0 ? ref : {}, message = ref1.message, error = ref1.error;
    return useMemo(function() {
        return {
            message: _objectSpread({}, message, hasError && error),
            error: error
        };
    }, [
        message,
        error,
        hasError
    ]);
};
export default useStyle;
